export enum WaterdataGroup {
  "WD_Users" = "WD_Users",
  "DHI_Users" = "DHI_Users",
  "Metocean_Plus" = "Metocean_Plus",
  "MOOD_Admin" = "MOOD_Admin",
  "SpecialData_Users" = "SpecialData_Users",
}

export enum SubscriptionType {
  "AnalyticsOnly" = "AnalyticsOnly",
  "DataOnly" = "DataOnly",
  "Unlimited" = "Unlimited",

  // Legacy Subcription Types
  "Bronze" = "Bronze",
  "Silver" = "Silver",
  "Gold" = "Gold",
}

export enum AnalyticsList {
  "limited" = "Limited",
  "all" = "All"
}

export enum DataAccess {
  "buy" = "Buy",
  "download" = "Download",
}

export interface UserGroupPermissions {
  waterdataGroup: WaterdataGroup | null;
  subscriptionType: SubscriptionType | null;
  analyticsList: AnalyticsList;
  dataAccess: DataAccess;
  dateRange: [moment.Moment, moment.Moment];
  analyticsDateRange: [moment.Moment, moment.Moment];
  validationDateRange: [moment.Moment, moment.Moment];
  confidentialDatasetIds: string[];
  spectraAccess: boolean;
}
